var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home-background fill-height justify-center",attrs:{"fluid":""}},[_c('v-img',{staticClass:"home-image",attrs:{"max-height":"400","max-width":"600","src":_vm.images.sample,"lazy-src":_vm.images.sample}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }